import { useState, useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { getAnalyticsConsent, setAnalyticsConsent } from '../utils/analyticsConsent';
import { Link } from 'react-router-dom';
import './AnalyticsConsentSettings.css';

/**
 * 設定パネル内のアクセス解析同意オン/オフ
 * 同意の撤回を設定画面で行えるようにする。
 */
const AnalyticsConsentSettings: React.FC = () => {
  const lang = useLanguage();
  const [consent, setConsent] = useState<boolean | null>(() => getAnalyticsConsent());

  useEffect(() => {
    setConsent(getAnalyticsConsent());
  }, []);

  const handleToggle = (accepted: boolean) => {
    setAnalyticsConsent(accepted);
    setConsent(accepted);
  };

  const title = lang === 'ja' ? 'アクセス解析' : 'Access analytics';
  const description =
    lang === 'ja'
      ? 'アクセス解析における端末情報（スマートフォン／タブレット等の種類）の取得可否を設定できます。'
      : 'Set whether device information (e.g. smartphone/tablet type) may be collected for access analytics.';
  const privacyLinkText = lang === 'ja' ? 'プライバシーポリシー' : 'Privacy Policy';
  const onLabel = lang === 'ja' ? '許可する' : 'Allow';
  const offLabel = lang === 'ja' ? '許可しない' : "Don't allow";

  const privacyUrl = `/${lang}/privacy-policy`;

  return (
    <div className="analytics-consent-settings">
      <div className="analytics-consent-settings__header">
        <h4 className="analytics-consent-settings__title">{title}</h4>
      </div>
      <p className="analytics-consent-settings__description">{description}</p>
      <p className="analytics-consent-settings__link-wrap">
        <Link to={privacyUrl} className="analytics-consent-settings__link">
          {privacyLinkText}
        </Link>
      </p>
      <div className="analytics-consent-settings__toggle" role="group" aria-label={title}>
        <button
          type="button"
          className={`analytics-consent-settings__btn ${consent === false ? 'analytics-consent-settings__btn--active' : ''}`}
          onClick={() => handleToggle(false)}
          aria-pressed={consent === false}
        >
          {offLabel}
        </button>
        <button
          type="button"
          className={`analytics-consent-settings__btn ${consent === true ? 'analytics-consent-settings__btn--active' : ''}`}
          onClick={() => handleToggle(true)}
          aria-pressed={consent === true}
        >
          {onLabel}
        </button>
      </div>
    </div>
  );
};

export default AnalyticsConsentSettings;
